import script from "./ViewFreelancerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewFreelancerComponent.vue?vue&type=script&setup=true&lang=js"

import "./ViewFreelancerComponent.vue?vue&type=style&index=0&id=6c1acb84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c1acb84"]])

export default __exports__